module.exports = require("@makemydeal/ui-bricks");